/*
 * sidebar (config)
 */
import type { AuthUser } from "@emr/types"
import {
	Calendar,
	Info,
	LayoutDashboard,
	Scale,
	Shield,
	SquareTerminal,
	User as UserIcon,
	Users,
} from "lucide-react"

export function getSidebarMenuList(
	user?: AuthUser | null,
	devMode?: boolean,
	_flags?: any,
): any[] {
	const dashboardGroup = {
		groupLabel: "",
		menus: [
			{
				to: "/dashboard",
				label: "Dashboard",
				icon: LayoutDashboard,
			},
		],
	}

	const menuList = [
		dashboardGroup,
		getMainMenuList(user),
		getBottomMenuList(user, devMode),
	].filter((group) => group)

	return menuList
}

/*
 * main
 */
function getMainMenuList(_user?: AuthUser | null) {
	const options: any = {
		groupLabel: "Services",
		menus: [
			{
				label: "Patients",
				icon: Users,
				to: "/patient",
			},
			{
				label: "Appointments",
				icon: Calendar,
				to: "/appointment",
			},
		],
	}

	return options
}

/*
 * bottom
 */
function getBottomMenuList(user?: AuthUser | null, devMode?: boolean) {
	const settings: any = { groupLabel: "Settings", menus: [] }

	if (user) {
		// Account
		settings.menus.push({
			to: "/auth/account",
			label: "Account",
			icon: UserIcon,
		})

		// Admin
		if ((user as any).user_metadata?.psychology?.isAdmin) {
			settings.menus.push({
				to: "/admin",
				label: "Admin",
				icon: Shield,
			})
		}
	}

	// Dev
	if (devMode) {
		settings.menus.push({
			to: "/dev",
			label: "Dev",
			icon: SquareTerminal,
		})
	}

	// Legal
	settings.menus.push({
		to: "/legal",
		label: "Legal",
		icon: Scale,
	})

	// About
	settings.menus.push({
		to: "/about",
		label: "About",
		icon: Info,
	})

	return settings
}
